import { Box, FormControl, FormControlLabel, FormLabel, Grid2, Input, Radio, RadioGroup, Stack } from "@mui/material";
import { NodeAction, nodeActions, NodeActionKeys } from "../types/A11yNode";
import { useTranslation } from "@fanfanlo";

export interface INodeActionUIParams{
    nodeAction:NodeAction
    setNodeAction:(nodeAction:NodeAction)=>void
    text:string
    setText:(text:string)=>void
}
export function NodeActionUI({nodeAction, setNodeAction, text, setText}: INodeActionUIParams) {
    const { t } = useTranslation("droid-project-v2-ext/actions/a11y/content")
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNodeAction(nodeActions[event.target.value])
      };

    return (
        <>
            <Box sx={{ width: "100%" }}>

                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">{t("NodeActionUI.title")}</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={nodeAction.value}
                        name="radio-buttons-group"
                        onChange={handleChange}
                    >
                        <FormControlLabel data-testid="NodeActionUI__clickRadio__01JFXYZT3J9K0L1M2N3O4P5Q6" value={NodeActionKeys.click} control={<Radio />} label={t("NodeActionUI.click")} />
                        <FormControlLabel data-testid="NodeActionUI__longClickRadio__01JFXYZU4K0L1M2N3O4P5Q6R7" value={NodeActionKeys.longClick} control={<Radio />} label={t("NodeActionUI.longClick")} />
                        <Grid2 direction="row" spacing={2} container>
                            <Grid2 size="auto">
                                <FormControlLabel data-testid="NodeActionUI__setTextRadio__01JFXYZV5L1M2N3O4P5Q6R7S8" value={NodeActionKeys.setText} control={<Radio />} label={t("NodeActionUI.setText")} />
                            </Grid2>
                            <Grid2 size="grow">
                                <Input data-testid="NodeActionUI__setTextInput__01JFXYZW6M2N3O4P5Q6R7S8T9" value={text} onChange={(e) => setText(e.target.value)} />
                            </Grid2>
                        </Grid2>
                        <FormControlLabel data-testid="NodeActionUI__tryClickRadio__01JFXYZX7N3O4P5Q6R7S8T9U0" value={NodeActionKeys.tryClick} control={<Radio />} label={t("NodeActionUI.tryClick")} />
                        <FormControlLabel data-testid="NodeActionUI__globalClickRadio__01JFXYZY8O4P5Q6R7S8T9U0V1" value={NodeActionKeys.globalClick} control={<Radio />} label={t("NodeActionUI.globalClick")} />
                    </RadioGroup>
                </FormControl>
            </Box>
        </>
    )
}
